/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */

import store from '@/store/store';
import { TypedUseSelectorHook, useSelector } from 'react-redux';

export const useAppSelector: TypedUseSelectorHook<ReturnType<typeof store.getState>> = useSelector;
